var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransmission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 36.291,
    height: 61.26,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(16.854 20.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(-3 -20)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M20.306,14.4c.209,2.248,2.7,4.061,4.778,4.641v8.21a1.446,1.446,0,0,0,1.446,1.446h1.095a1.446,1.446,0,0,0,1.446-1.446v-8.2c2.081-.58,4.57-2.405,4.778-4.653l.839-9.033A4.463,4.463,0,0,0,31.579.68,15.249,15.249,0,0,0,22.6.671a4.47,4.47,0,0,0-3.135,4.691Z",
    transform: "translate(-2.026 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M31.28,18.93a8.471,8.471,0,0,1-3.593,2.437v5.112l1.819-.01a.788.788,0,0,1,.791.787V39.187a.787.787,0,0,1-.787.787h-1.6a.788.788,0,0,0-.787.787v4.075a.787.787,0,0,1-.787.787H25a.788.788,0,0,0-.787.787v5.875a.787.787,0,0,1-.787.787H18.517a.787.787,0,0,0-.787.787v1.62a.788.788,0,0,1-.787.788H13.6a.788.788,0,0,1-.787-.788V45.752a.788.788,0,0,1,.787-.787h3.338a.787.787,0,0,1,.787.787v1.621a.787.787,0,1,0,1.575,0V41.5a.788.788,0,0,1,.787-.788H21.42a.787.787,0,0,0,.787-.787V35.849a.787.787,0,0,1,.787-.787h1.6a.787.787,0,0,0,.787-.787v-2.1a.787.787,0,0,0-.8-.787l-1.6.021a.787.787,0,0,1-.8-.787V27.289a.784.784,0,0,1,.211-.536v-5.4a7.789,7.789,0,0,1-4.358-3.619H9.678A9.677,9.677,0,0,0,0,27.409V53.177a9.929,9.929,0,0,0,9.929,9.93H26.361a9.93,9.93,0,0,0,9.93-9.93V27.409A9.675,9.675,0,0,0,31.28,18.93M9.355,52.362a.725.725,0,0,1-.725.726H5.61a.725.725,0,0,1-.725-.726v-3.02a.724.724,0,0,1,.725-.725H8.63a.724.724,0,0,1,.725.725Zm0-6.806a.724.724,0,0,1-.725.725H5.61a.724.724,0,0,1-.725-.725v-3.02a.725.725,0,0,1,.725-.726H8.63a.725.725,0,0,1,.725.726Zm0-6.806a.724.724,0,0,1-.725.725H5.61a.724.724,0,0,1-.725-.725V35.73a.724.724,0,0,1,.725-.725H8.63a.724.724,0,0,1,.725.725Zm0-8.537a.724.724,0,0,1-.725.725H5.61a.724.724,0,0,1-.725-.725V27.193a.725.725,0,0,1,.725-.725H8.63a.725.725,0,0,1,.725.725Z",
    transform: "translate(0 -1.847)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 64,
    height: 65,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmission);
export default __webpack_public_path__ + "static/media/transmission.252ace382e12a72220ca18c19a42f013.svg";
export { ForwardRef as ReactComponent };